// extracted by mini-css-extract-plugin
var _1 = "vg3uAmygzIFdYCLB3sJo";
var _2 = "xYLEat_wjBx85ltsYjTP";
var _3 = "cQnSXyMe1Fociqsh427B";
export { _1 as "content", _2 as "control", _3 as "typographyStylesProvider" }
